
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from 'vue';
Vue.directive('select-overflow', {
    inserted: (el, _binding, vnode) => {
      let originalWidth;
      let originalPosition;
      let originalZIndex;
      let selectIsOpen = false;
      let dropdown;
      let originalTopDropdown;
      const psContainer = el.closest('.ps-container');
      const modalScroll = el.closest('.modal-scroll');
      const windowInnerHeight = window.innerHeight;

      for (let i = 0; i < el.childNodes.length; i++) {
        if(el.childNodes[i].className && el.childNodes[i].className.includes('multiselect__content-wrapper')) {
          dropdown = el.childNodes[i];
          break;
        }
      }

      vnode.child.$watch('isOpen', isOpen => {
        selectIsOpen = isOpen;
        if (isOpen) {
          const { offsetWidth } = el;
          const viewportOffset = el.getBoundingClientRect();
          const top = viewportOffset.top;
          originalWidth = el.style.width;
          originalPosition = el.style.position;
          originalZIndex = el.style.zIndex;
          el.style.width = `${offsetWidth}px`;
          el.style.position = 'fixed';
          el.style.transform = `translateY(${  -psContainer.scrollTop - modalScroll.scrollTop }px)` ;
          el.style.zIndex = 2;

          const _maxHeight = 150;
          if (windowInnerHeight - top < _maxHeight) {
            originalTopDropdown = dropdown.style.top;
           dropdown.style.maxHeight = '150px';
          //  dropdown.style.top = 'calc(-100%)';
           dropdown.style.transform = `translateY(calc(-100% - 48px))`;
          }
        } else {
          el.style.position = originalPosition;
          el.style.width = originalWidth;
          el.style.zIndex = originalZIndex;
          el.style.transform = 'translateY(0)';
          dropdown.style.top = originalTopDropdown;
          dropdown.style.transform = `translateY(0)`;
        }
      });
      function closeDropdownOnScroll(el, selectIsOpen, dropdown) {
        if (selectIsOpen) {
          el.style.position = originalPosition;
          el.style.width = originalWidth;
          el.style.zIndex = originalZIndex;
          el.style.transform = 'translateY(0)';
          el.classList.remove('multiselect--active');
          // el.querySelector('input').blur();
          dropdown.style.display = 'none';
        }
      }

      'wheel scroll'.split(' ').forEach((e)=>{
        if (modalScroll) {
          modalScroll.addEventListener(e, () => {
            closeDropdownOnScroll(el,selectIsOpen,dropdown);
          }, false);
        }
        if (psContainer) {
          psContainer.addEventListener(e, () => {
            closeDropdownOnScroll(el,selectIsOpen,dropdown);
          }, false);
        }
      });
    }
  });
